import { render, staticRenderFns } from "./editOwnersTable.vue?vue&type=template&id=5b223cfc"
import script from "./editOwnersTable.vue?vue&type=script&lang=js"
export * from "./editOwnersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports